"use client";

import ClienteForm from '@components/cms/ClienteForm/page';
import BoxUi from '@components/common/BoxUi';
import LineBreaker from '@components/common/LineBreaker';
import TitleUi from '@components/common/TitleUi';
import CmsLayout from '@layouts/CmsLayout';
import { CSS_HELPERS, MEDIA_SCREENS, THEME_COLORS } from '@theme/constants';
import { Col, Row } from 'antd';
import styled from 'styled-components';

const Cliente = () => {
    return (
        <CmsLayout>
            <View>
                {/* <BoxUi>
          <Row gutter={[30, 15]}>
            <Col xs={24} sm={12} >
              <div className='picContainer'>
                <img className="pic" src={'http://127.0.0.1:8001/figuras/589.webp'} alt="Genesis" />
                <div className="picOverlay" />
              </div>
            </Col>
            <Col xs={24} sm={10}  >
              <Row gutter={[15, 15]} style={{ background: '', height: '100%' }} >
                <Col xs={24}>
                  <Row gutter={[15, 15]}>
                    <Col xs={24}>
                      <TitleUi
                        titulo={'titulo'}
                        noMarginX
                        variant={"color_box"}
                      />
                    </Col>
                    <Col xs={24} >
                      {
                        // customParts ?
                        //   <p>
                        //     {customParts.least}
                        //     <span>
                        //       <Link href={customParts.link}>
                        //         <a className='light_primary_main'>
                        //           {customParts.text}
                        //         </a>
                        //       </Link>
                        //     </span>
                        //   </p>
                        //   :
                        <p>
                          {<LineBreaker titulo={'descripcion_larga'} boldColor={THEME_COLORS.light.primary.alt} />}
                        </p>
                      }
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </BoxUi> */}
                <img src="/img/banner1.jpg" alt="Invierte tus utilidades." width="100%" />
            </View>
            <ClienteForm />
        </CmsLayout>
    )
}

const View = styled.div`
    .titulo_box {
        display: flex;
        h2{
            overflow: hidden;
            border-radius: ${CSS_HELPERS.RADIUS};
            border-top-right-radius: 200px;
            color:${THEME_COLORS.light.primary.contrastText};
            background-color:${THEME_COLORS.light.primary.alt};
            padding: .3em;
            padding-right: 3em;
           ${CSS_HELPERS.BORDER_LINE_BOTTOM}
        }
    };

    .categoria_descripcion_box{
        height: 15em;
        padding: 1em 0;
    }

    .picContainer{
        border-radius: 0 20pt 20pt 0;
        height: 33em;
        overflow: hidden;
        position:relative ;
        @media screen and  (min-width: ${0}px) and (max-width: ${MEDIA_SCREENS.XS}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.XS}px) and (max-width: ${MEDIA_SCREENS.SM}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.SM}px) and (max-width: ${MEDIA_SCREENS.MD}px) { 
        width:100%;
        }
        @media screen and  (min-width: ${MEDIA_SCREENS.MD}px) and (max-width: ${MEDIA_SCREENS.LG}px) { 
        width:100%;
        }
        .picOverlay{
            width:100% ;
            height: 33em;
            position:absolute;
            z-index:3;
            top:0;
            /* background: linear-gradient(90deg, #FFFFFF85 12%, #FFFFFF00 60%); */
            border-bottom: .6em solid ${THEME_COLORS.light.secondary.main};
            border-radius:0 20pt 20pt 0;

        }
        .pic{
            object-fit:cover;
            width:100%; 
            border-radius:0 20pt 20pt 0 ;
            overflow:hidden ;
            max-width:100%;
            width:100%;
            height:100%;
        }


    }
`

export default Cliente;